import { BranchType } from '@/view-models/branch'
import { parsePureHintText } from '@/utils/parser'

export function useFunbookBranchFromStore(bid = ref('')) {
  const nuxtApp = useNuxtApp()
  const { $store: store } = useNuxtApp()
  const branch = computed(() => store.state.branch.branch)

  const merchantBranches = computed(() => store.getters['branch/getMerchantBranches']([BranchType.FunBook, BranchType.Mix]) || [])

  const otherBranches = computed(() => merchantBranches.value?.filter(branch => branch.bid !== bid.value && branch.type !== BranchType.FunNow))
  const otherBranchTitle = computed(() => nuxtApp.$i18n.t('other_branch', { branchname: branch.value.name }))

  const branchIntro = computed(() => branch.value?.fb_intro ?? '')

  const needToKnowItems = computed(() => parsePureHintText(branch.value.fb_need_to_know))

  return {
    branch,
    merchantBranches,
    otherBranchTitle,
    otherBranches,
    branchIntro,
    needToKnowItems,
  }
}

export function useFunBookV2() {
  const route = useRoute()
  const branchId = computed(() => route.params.branch_id)
  const homePath = computed(() => `/funbook/${branchId.value}/branch`)

  return {
    branchId,
    homePath,
  }
}
